import { render, staticRenderFns } from "./RadialBarChart.vue?vue&type=template&id=0f9c434e&scoped=true&"
import script from "./RadialBarChart.vue?vue&type=script&lang=js&"
export * from "./RadialBarChart.vue?vue&type=script&lang=js&"
import style0 from "./RadialBarChart.vue?vue&type=style&index=0&id=0f9c434e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c434e",
  null
  
)

export default component.exports